import React from 'react';
import Chip from '@mui/material/Chip';
import StarIcon from '@mui/icons-material/Star';
import styled from 'styled-components';

const CustomChip = styled(Chip)`
  text-transform: none;
  font-weight: 500;
  position: absolute;
  top: -12.5px;
  left: 5px;
  font-size: 0.75rem;
  height: 25px;
`;

function ChipAvista() {
  return (
    <CustomChip
      size="small"
      icon={
        <StarIcon
          style={{ color: 'white', height: 10, width: 10, marginLeft: 10 }}
        />
      }
      color="secondary"
      label="Economize Mais"
    />
  );
}

export default ChipAvista;
